// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab__session .button__create-a-session{width:160px!important;height:40px!important;padding:0 0}.tab__session .container__session-row{width:100%}", ""]);
// Exports
module.exports = exports;
